"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _iconButton = _interopRequireDefault(require("./icon-button"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// FUTURE: support for hamburger menus
var FormCardButtons = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(FormCardButtons, _React$PureComponent);

  var _super = _createSuper(FormCardButtons);

  function FormCardButtons() {
    (0, _classCallCheck2.default)(this, FormCardButtons);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FormCardButtons, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          forbidUpdate = _this$props.forbidUpdate,
          forbidDelete = _this$props.forbidDelete,
          editable = _this$props.editable,
          disabled = _this$props.disabled,
          archivedAt = _this$props.archivedAt,
          onEdit = _this$props.onEdit,
          onDelete = _this$props.onDelete,
          id = _this$props.id;
      var updateButton = null;

      if (!forbidUpdate) {
        updateButton = /*#__PURE__*/_react.default.createElement(_iconButton.default, {
          onClick: onEdit,
          icon: "Edit",
          tooltip: "Edit",
          "aria-label": "Edit ".concat(id)
        });
      }

      var deleteButton = null;

      if (!forbidDelete) {
        var title = archivedAt ? 'Restore' : 'Delete';
        deleteButton = /*#__PURE__*/_react.default.createElement(_iconButton.default, {
          onClick: onDelete,
          icon: title,
          tooltip: title,
          "aria-label": "Delete ".concat(id)
        });
      }

      if (editable && !disabled && (!forbidUpdate || !forbidDelete)) {
        return /*#__PURE__*/_react.default.createElement(_Grid.default, {
          item: true
        }, updateButton, deleteButton);
      } else {
        return null;
      }
    }
  }]);
  return FormCardButtons;
}(_react.default.PureComponent);

exports.default = FormCardButtons;